import { api } from './api';

// Define a api key service
export const apiKeyApi = api.injectEndpoints({
  reducerPath: 'apiKeyApi',
  tagTypes: ['ApiKeys'],
  endpoints: (builder) => ({
    getApiKeys: builder.query({
      query: () => ({
        url: `/api/administration/keys`,
        method: 'GET'
      }),
      providesTags: ['ApiKeys']
    }),
    createApiKey: builder.mutation({
      query: (apiKeyRequest) => ({
        url: `/api/administration/keys`,
        method: 'POST',
        body: apiKeyRequest
      }),
      invalidatesTags: ['ApiKeys']
    }),
    updateApiKey: builder.mutation({
      query: ({ apiKeyId, apiKeyRequest }) => ({
        url: `/api/administration/keys/${apiKeyId}`,
        method: 'PATCH',
        body: apiKeyRequest
      }),
      invalidatesTags: ['ApiKeys']
    }),
    deleteApiKey: builder.mutation({
      query: (apiKeyId) => ({
        url: `/api/administration/keys/${apiKeyId}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['ApiKeys']
    }),
    bulkDeleteApiKeys: builder.mutation({
      query: (apiKeyIds) => ({
        url: `/api/administration/keys`,
        method: 'DELETE',
        body: apiKeyIds
      }),
      invalidatesTags: ['ApiKeys']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetApiKeysQuery,
  useCreateApiKeyMutation,
  useUpdateApiKeyMutation,
  useDeleteApiKeyMutation,
  useBulkDeleteApiKeysMutation
} = apiKeyApi;
